import {toAbsoluteUrl} from '../../../helpers'

export function FallbackView() {
  return (
    <div className='splash-screen'>
      <img src={toAbsoluteUrl('/media/logos/doora-logo.png')} alt='Doora' width='200px' />
      <span>Loading ...</span>
    </div>
  )
}
